import { VscArrowSwap } from 'react-icons/vsc';
import { LuDownload } from 'react-icons/lu';
import { BsSend } from 'react-icons/bs';
import Link from 'next/link';
import CustomDialog from '@/components/ui/customDialog';
import TokenToSend from './TokenToSend';
import Deposit from '@/components/deposit';
export default function ActionsPortfolio() {
  return <div className='genius-shadow p-3 gap-1 grid grid-cols-3 items-center bg-genius-indigo rounded-[20px] border-genius-blue border-[1px] ta-c justify-between' data-sentry-component="ActionsPortfolio" data-sentry-source-file="ActionsPortfolio.tsx">
      {/* <div
                onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
                <div className="flex items-center w-full h-[56px] bg-genius-blue bg-genius-blue rounded-[20px] justify-center">
                    <AiFillBank className="h-[20px] w-[20px]" />
                </div>
                <p className="text-[14px]">Cash Out</p>
            </div> */}

      <CustomDialog className={'h-fit w-[572px]'} trigger={<div className='cursor-pointer'>
            <div className='flex items-center w-full h-[56px] bg-genius-blue rounded-[20px] justify-center'>
              <LuDownload className='h-[18px] w-[18px]' />
            </div>
            <p className='text-[14px]'>Deposit</p>
          </div>} data-sentry-element="CustomDialog" data-sentry-source-file="ActionsPortfolio.tsx">
        <Deposit data-sentry-element="Deposit" data-sentry-source-file="ActionsPortfolio.tsx" />
      </CustomDialog>

      <CustomDialog className={'p-0 h-[522px] w-[572px]'} trigger={<div className='cursor-pointer'>
            <div className='flex items-center w-full h-[56px] bg-genius-blue rounded-[20px] justify-center'>
              <BsSend className='h-[18px] w-[18px]' />
            </div>
            <p className='text-[14px]'>Send</p>
          </div>} data-sentry-element="CustomDialog" data-sentry-source-file="ActionsPortfolio.tsx">
        <TokenToSend data-sentry-element="TokenToSend" data-sentry-source-file="ActionsPortfolio.tsx" />
      </CustomDialog>

      <Link href='/trade' data-sentry-element="Link" data-sentry-source-file="ActionsPortfolio.tsx">
        <div className='cursor-pointer'>
          <div className='flex items-center w-full h-[56px] bg-genius-blue rounded-[20px] justify-center'>
            <VscArrowSwap className='h-[18px] w-[18px]' data-sentry-element="VscArrowSwap" data-sentry-source-file="ActionsPortfolio.tsx" />
          </div>
          <p className='text-[14px]'>Swap</p>
        </div>
      </Link>
    </div>;
}